module.exports = {
  // CONTAINERS AND BREAKPOINTS
  CONTAINER_SM: 540,
  CONTAINER_MD: 769,
  CONTAINER_LG: 992,
  CONTAINER_XL: 1170,
  BREAKPOINT_SM: 540,
  BREAKPOINT_MD: 769,
  BREAKPOINT_LG: 992,
  BREAKPOINT_XL: 1170,

  // OFFSETS
  TOP_OFFSET: 138,

  // DATES
  DATE_DISPLAY_FORMAT: 'MM/DD/YYYY',

  // KEYCODES
  ESCAPE_KEYCODE: 27,
  ARROW_LEFT_KEYCODE: 37,
  ARROW_UP_KEYCODE: 38,
  ARROW_RIGHT_KEYCODE: 39,
  ARROW_DOWN_KEYCODE: 40,

  ACCORDION_ANIMATION_TIME: 350
};
